export function NavItem({ icon, label, active, onClick, badge }) {
  return (
    <button onClick={onClick}
      className={`w-full flex items-center gap-4 px-6 py-4 text-left
        ${active
          ? 'bg-primary-container text-on-primary-fixed font-extrabold border-l-4 border-on-background'
          : 'text-on-surface font-medium border-l-4 border-transparent'}`}
    >
      <span className="material-symbols-outlined text-[22px]" style={{ fontVariationSettings: active ? "'FILL' 1" : "'FILL' 0" }}>{icon}</span>
      <span className="text-[15px] tracking-tight flex-1">{label}</span>
      {badge && (
        <span className={`text-[9px] font-bold uppercase tracking-widest px-1.5 py-0.5 border-2 ${active ? 'border-on-primary-fixed/30 text-on-primary-fixed/70' : 'border-on-background/20 text-on-surface-variant bg-surface-container'}`}>
          {badge}
        </span>
      )}
    </button>
  )
}